import React from 'react';
import Slider from "react-slick";
import Media from "react-media";
import {MD_BREAKPOINT} from "../../../../Constants/Constants";
import posed from "react-pose";

export const CarouselItem = (props) => (
	<div style={{
		zIndex: 0,
		display: "flex",
		flexDirection: "column",
		justifyContent: "space-between",
		alignItems: "center",
		textAlign: "center"
	}}>
		<div style={(({fontFamily, lineHeight, padding, color, fontStyle})=>({fontFamily, lineHeight, padding, color, fontStyle}))(props.styles.contentContainer)}>
			<h1 style={{...props.styles.subtitle, zIndex: 0}}>{props.title}</h1>
			<h2 style={{...props.styles.subtitle, fontStyle: 'italic', zIndex: 0}}>{props.subTitle}</h2>
			<p style={{zIndex: 0}}>{props.description}</p>
			{
				props.data ?
					<ul style={{textAlign: "left", listStyle: "none", zIndex: 0}}>
						{props.data.map((item, index) => <li  style={{zIndex: 0}} key={index}>{item}</li>)}
					</ul>
					: null
			}
		</div>
	</div>
);

function SampleNextArrow(props) {
	const { className, style, onClick } = props;
	// const sample = (({position, top})=>({position, top}))(style);
	return (
		<div
			className={className}
			style={{...style, color: "#000"}}
			onClick={onClick}
		/>
	);
}

function SamplePrevArrow(props) {
	const { className, style, onClick } = props;
	return (
		<div
			className={className}
			style={{ ...style, color: "#000"}}
			onClick={onClick}
		/>
	);
}

class Carousel extends React.Component {
	constructor(props) {
		super(props);
		let items = props.items ? props.items : [];
		//console.log("Carousel props", props.items);

		this.state = {
			items: items,
			settings: {
				dots: true,
				infinite: true,
				speed: 1000,
				autoplay: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				// fade: true,
				focusOnChange: true,
				// prevArrow: '<button><span class="fa fa-long-arrow-left"></span></button>',
				// nextArrow: '<button><span class="fa fa-long-arrow-right"></span></button>',
				// prevArrow: (<button className="slick-arrow prev"></button>),
				// nextArrow: (<button className="slick-arrow next"></button>),
				// prevArrow: <SamplePrevArrow/>,
				// nextArrow: <SampleNextArrow/>,
				zIndex: 0
			}
		}
	}

	styles = {
		slickButton: {
			color: "black",
			fontSize: "2rem",
			padding: "1rem",
		}
	};
	render() {
		//console.log("Carousel Items", this.state.items);
		return (
			<div style={{padding: "1rem 0.25rem 2rem 0.25rem", zIndex: 0}}>
				<Slider {...this.state.settings} style={{zIndex: 0}}>
					{
						this.state.items.map((item, index) => <CommonListItem styles={this.props.styles} key={index} {...item}/>)
					}
				</Slider>
			</div>
		);
	}
}

export const CommonListItem = (props) => {
	//console.log(props);

	const title = <div key="title" style={{...props.styles.subTitle, maxWidth:"100%"}}>{props.title}</div>;
	const subtitle = <div key="subtitle" style={{fontStyle: 'italic', maxWidth:"100%"}}>{props.subTitle}</div>;
	const description = props.description && (
		<ul key="description" style={{textAlign: "justify", marginTop: "1rem"}}>
			{props.description.map((item, index)=><li key={index}>{item}</li>)}
		</ul>
	);

	return (
		<HoverPose>
			<div style={{...props.styles.contentContainer, padding:"1rem", borderRadius: "1rem", margin: "1rem", textAlign: "center",background: "rgba(255,255,255,0.5)", boxShadow: "2px 2px 20px black"}}>
				<div style={{display: 'flex', flexDirection: "column"}}>
					{[title, subtitle, description]}
				</div>
			</div>
		</HoverPose>
	);
};

const HoverPose = posed.div({
	hoverable: true,
	init: {scale: 1},
	hover: {
		scale: 1.01,
	},
	pressable: true,
	press: { scale: 0.95},
	transition: { type: 'spring' }
});

export default Carousel;